// Tiny Web-Audio synth for a thermal-printer sound + paper tear.
// No audio assets required — everything is generated from noise + oscillators.

let ctx;
function ac() {
  if (!ctx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    ctx = new Ctx();
  }
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

// Fill a buffer with white noise
function noiseBuffer(seconds, sampleRate) {
  const len = Math.floor(sampleRate * seconds);
  const buf = ctx.createBuffer(1, len, sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
  return buf;
}

// One short "buzz click" — the noise a thermal printer makes as each line prints.
function playClick(t, gain = 0.08) {
  const c = ac();
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(0.045, c.sampleRate);
  const bp = c.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.value = 2200 + Math.random() * 800;
  bp.Q.value = 6;
  const g = c.createGain();
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.045);
  src.connect(bp).connect(g).connect(c.destination);
  src.start(t);
  src.stop(t + 0.06);
}

// The paper-tear: filtered noise with a downward frequency sweep.
function playTear(t) {
  const c = ac();
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(0.35, c.sampleRate);
  const hp = c.createBiquadFilter();
  hp.type = 'highpass';
  hp.frequency.setValueAtTime(1800, t);
  hp.frequency.exponentialRampToValueAtTime(400, t + 0.32);
  const bp = c.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.setValueAtTime(3500, t);
  bp.frequency.exponentialRampToValueAtTime(900, t + 0.32);
  bp.Q.value = 1.2;
  const g = c.createGain();
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(0.18, t + 0.02);
  g.gain.setValueAtTime(0.18, t + 0.18);
  g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
  src.connect(hp).connect(bp).connect(g).connect(c.destination);
  src.start(t);
  src.stop(t + 0.4);
}

export function playPrinter() {
  try {
    const c = ac();
    const start = c.currentTime + 0.02;
    // ~1.3 seconds of print buzzes at ~55Hz "line rate"
    const duration = 1.3;
    const rate = 55;
    const count = Math.floor(duration * rate);
    for (let i = 0; i < count; i++) {
      const t = start + i / rate + (Math.random() * 0.006);
      const gain = 0.05 + Math.random() * 0.05;
      playClick(t, gain);
    }
    // Tear the paper at the end
    playTear(start + duration + 0.05);
  } catch (_) {
    // no-op if the AudioContext can't start (e.g. no user gesture yet)
  }
}
